export default "__VITE_ASSET__Dizt_Khs__"